import { render, staticRenderFns } from "./Col7.vue?vue&type=template&id=c30fdc7c&scoped=true"
import script from "./Col7.vue?vue&type=script&lang=js"
export * from "./Col7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30fdc7c",
  null
  
)

export default component.exports